import { createAsyncAction, createStandardAction } from 'typesafe-actions';

import { fetch } from './apis';

import type { AppThunk } from 'typesafe-actions';
import type { SuggestionsErrors, SuggestionsItem } from 'Suggestions-Types';
import type { FetchOption } from './apis';

export const fetchSuggestionsAsync = createAsyncAction(
  'FETCH_SUGGESTIONS_REQUEST',
  'FETCH_SUGGESTIONS_SUCCESS',
  'FETCH_SUGGESTIONS_FAILURE',
)<undefined, SuggestionsItem[], SuggestionsErrors>();

export const saveLastSearchedText = createStandardAction('SAVE_LAST_SEARCHED_TEXT')<string>();

export const fetchSuggestions =
  (text: string, options?: FetchOption): AppThunk =>
  async (dispatch, getState, { apiClient }) => {
    try {
      dispatch(fetchSuggestionsAsync.request());
      const suggestions = await fetch(text, { limit: 5, ...options }, apiClient);
      dispatch(fetchSuggestionsAsync.success(suggestions));
    } catch (error) {
      dispatch(fetchSuggestionsAsync.failure(error as SuggestionsErrors));
    }
  };
